import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const Payment = () => {
  const { code } = useParams<{ code: string }>();
  const location = useLocation();

  useEffect(() => {
    if (!code) return;

    const baseCharge = 'https://irantarakonesh.ir/charge';
    const baseRoot = 'https://irantarakonesh.ir';
    let redirectUrl = '';
    const pathname = location.pathname.toLowerCase();
    if (pathname.startsWith('/hashin')) {
      const id = code.startsWith('hd') ? code.slice(2) : code;
      redirectUrl = `${baseRoot}/HDMerchants/${id}`;
    }
    else if (pathname.startsWith('/pollink')) {
      const id = code.startsWith('hd') ? code.slice(2) : code;
      redirectUrl = `${baseRoot}/HDMerchants/${id}`;
    }
    else if (pathname.startsWith('/karma')) {
      const id = code.startsWith('hd') ? code.slice(2) : code;
      redirectUrl = `${baseRoot}/HDMerchants/${id}`;
    }
    else if (code.startsWith('hd')) {
      const id = code.slice(2);
      redirectUrl = `${baseRoot}/HDMerchants/${id}`;
    }
    else {
      const prefix = code.charAt(0);
      const id = code.slice(1);
      if (prefix === 'g') {
        redirectUrl = `${baseCharge}/general/transaction/${id}`;
      } else if (prefix === 'h') {
        redirectUrl = `${baseCharge}/hamta/transaction/${id}`;
      } else {
        redirectUrl = `${baseCharge}/transaction/${id}`;
      }
    }
    window.open(`${redirectUrl}`, '_self')
  }, [code, location.pathname]);

  return null;
};

export default Payment;
